import _asyncToGenerator from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/@babel+runtime@7.14.6/node_modules/@babel/runtime/regenerator/index.js";
import { useEffect, useRef } from 'react';
// eslint-disable-next-line import/no-unresolved
import { useLazyQuery } from '@apollo/react-hooks';
import window from 'global/window';
import _ from 'lodash';
import { formatName } from 'shared/helpers/users';
import generateDecagonUserAuth from 'shared/graphql/decagon/queries/generate-decagon-user-auth.gql';
import useStores from './use-stores';
import { hideZendeskWidget, showDecagonWidget, closeZendeskWidget } from '../helpers/tools';
export default function useConsumerChatWidget() {
  var _useStores = useStores(),
    UI = _useStores.UI,
    User = _useStores.User,
    Cart = _useStores.Cart;
  var metadataSetRef = useRef(false);
  var _useLazyQuery = useLazyQuery(generateDecagonUserAuth, {
      fetchPolicy: 'network-only'
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 1),
    fetchUserAuth = _useLazyQuery2[0];
  useEffect(function () {
    closeZendeskWidget();
    hideZendeskWidget();
    return initializeDecagon(UI);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    var applyIdentity = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _auth, auth, _data$generateDecagon, _yield$fetchUserAuth, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!User.exists) {
                _context.next = 18;
                break;
              }
              // Decagon establishes the conversation the moment setUserId fires, so the signed
              // (signature, epoch) must be applied in the same turn — otherwise the conversation
              // is tagged _decagon_has_valid_signature:false and never recovers. Lower envs
              // without the HMAC secret return nulls and we fall through to unsigned.
              auth = null;
              _context.prev = 2;
              _context.next = 5;
              return fetchUserAuth();
            case 5:
              _yield$fetchUserAuth = _context.sent;
              data = _yield$fetchUserAuth.data;
              auth = (_data$generateDecagon = data === null || data === void 0 ? void 0 : data.generateDecagonUserAuth) !== null && _data$generateDecagon !== void 0 ? _data$generateDecagon : null;
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.error('Failed to fetch Decagon user auth signature', _context.t0);
            case 13:
              window.duet.setUserId(User.id);
              if ((_auth = auth) !== null && _auth !== void 0 && _auth.signature && typeof auth.epoch === 'number') {
                window.duet.setUserIdAuth(auth.signature, auth.epoch);
              }
              window.duet.setMetadata({
                email: User.email,
                name: User.fullName,
                phone: User.phone,
                userType: 'consumer'
              });
              _context.next = 19;
              break;
            case 18:
              if (Cart.guestCustomer) {
                window.duet.setMetadata({
                  phone: Cart.guestCustomer.phone,
                  name: formatName(Cart.guestCustomer),
                  userType: 'consumer'
                });
              }
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 10]]);
      }));
      return function applyIdentity() {
        return _ref.apply(this, arguments);
      };
    }();

    // Poll for window.duet to become available, then set metadata once
    var interval = setInterval(function () {
      if (window.duet && !metadataSetRef.current) {
        metadataSetRef.current = true;
        clearInterval(interval);
        applyIdentity()["catch"](function (err) {
          return console.error('Failed to apply Decagon identity', err);
        });
      }
    }, 100);
    return function () {
      return clearInterval(interval);
    };
    // Don't update mid-conversation or else Decagon clears the chat history and confuses the end user
    // Only set metadata once when window.duet becomes available
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchUserAuth]);
}
function initializeDecagon(UI) {
  // Skip Decagon in E2E test environments - the widget's high z-index (99999999)
  // interferes with MUI modals during Playwright tests
  if (typeof window !== 'undefined' && window.__PLAYWRIGHT_TEST__) {
    return _.noop;
  }
  if (UI.isVariant("default") && !window.duet) {
    var decagonInitScript = document.createElement("script");
    decagonInitScript.id = "chat-loader";
    decagonInitScript.src = "https://decagon.ai/loaders/dutchie.js";
    decagonInitScript.async = true;
    document.body.appendChild(decagonInitScript);
  }

  // make sure it's not hidden from before
  showDecagonWidget();
  return function () {
    var _window$duet;
    return (_window$duet = window.duet) === null || _window$duet === void 0 ? void 0 : _window$duet.hide();
  };
}